function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m113.206 106.265h-13.623v-86.28a1.749 1.749 0 0 0 -1.554-1.738l-46-5.192a1.75 1.75 0 0 0 -1.946 1.739v3.441h-19.916a1.75 1.75 0 0 0 -1.75 1.75v86.28h-13.623a1.75 1.75 0 1 0 0 3.5h35.289v3.441a1.75 1.75 0 0 0 1.75 1.75 1.61 1.61 0 0 0 .2-.011l45.9-5.18h15.276a1.75 1.75 0 0 0 0-3.5zm-81.289-84.53h18.166v4.5h-11.917a1.75 1.75 0 0 0 -1.75 1.75v78.28h-4.5zm8 84.53v-76.53h10.166v76.53zm13.666-89.513 42.5 4.8v84.9l-42.5 4.8z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m61.125 58.792a5.208 5.208 0 1 0 5.208 5.208 5.214 5.214 0 0 0 -5.208-5.208zm0 6.916a1.708 1.708 0 1 1 1.708-1.708 1.71 1.71 0 0 1 -1.708 1.708z"
});

var SvgDoor = function SvgDoor(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 128 128",
    width: 512,
    "data-name": "Layer 1",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDoor, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/door.b09b4ccc.svg";
export { ForwardRef as ReactComponent };